module.exports = __webpack_public_path__ + "static/media/ZEVEN.bd108515.svg";